import moment from "moment";
import { useTarifinfosStore } from '../stores/tarifinfos.js';
import { getBankname } from '../api/BankService.js';

export function DatumTTMMJJJ(dateString) {
    const parts = dateString.split(".");
    if (parts.length === 3) {
        const date = new Date(parts[2], parts[1] - 1, parts[0]);
        if (!isNaN(date.getTime())) {
            return `${parts[0]}.${parts[1]}.${parts[2]}`;
        } else {
            return "";
        }
    } else {
        return "";
    }
}

export function DatumISO(dateString) {
    if (!dateString || typeof dateString !== 'string') return "";
    
    // Format YYYY-MM-DD (AR20/ARN) - bereits ISO-Format, nur validieren
    if (dateString.includes('-')) {
        const parts = dateString.split("-");
        if (parts.length === 3) {
            const date = new Date(parts[0], parts[1] - 1, parts[2]);
            if (!isNaN(date.getTime())) {
                return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
            }
        }
        return "";
    }
    
    // Format DD.MM.YYYY (Kombirechner) - zu ISO konvertieren
    const parts = dateString.split(".");
    if (parts.length === 3) {
        const date = new Date(parts[2], parts[1] - 1, parts[0]);
        if (!isNaN(date.getTime())) {
            return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        } else {
            return "";
        }
    } else {
        return "";
    }
}

export function DatumISO2(dateString) {
    const parts = dateString.split("-");
    if (parts.length === 3) {
        const date = new Date(parts[0], parts[1] - 1, parts[2]);
        if (!isNaN(date.getTime())) {
            return `${parts[0]}-${parts[1]}-${parts[2]}`;
        } else {
            return "";
        }
    } else {
        return "";
    }
}


export function isValidDate(dateString) {
    if (typeof dateString !== 'string') return false;
    
    // Unterstütze Format DD.MM.YYYY (Kombi)
    if (dateString.includes('.')) {
        const parts = dateString.split(".");
        if (parts.length === 3) {
            const date = new Date(parts[2], parts[1] - 1, parts[0]);
            return !isNaN(date.getTime());
        }
        return false;
    }
    
    // Unterstütze Format YYYY-MM-DD (AR20)
    if (dateString.includes('-')) {
        const parts = dateString.split("-");
        if (parts.length === 3) {
            const date = new Date(parts[0], parts[1] - 1, parts[2]);
            return !isNaN(date.getTime());
        }
        return false;
    }
    
    return false;
}

export function isValidDateInPast(dateString) {
    if (typeof dateString !== 'string') return false;

    const date = moment(dateString, 'YYYY-MM-DD', true);
    if (!date.isValid()) return false;

    const today = moment().startOf('day');
    const minDate = today.clone().subtract(105, 'years');

    return date.isBetween(minDate, today, null, '[]');
}

function isMinimum18(birthdate) {
    const birthDate = moment(birthdate, 'YYYY-MM-DD', true);
    if (!birthDate.isValid()) return false;

    const today = moment().startOf('day');
    const age = today.diff(birthDate, 'years');
    return age >= 18;
}

export function isValidDateInPast18(dateString) {

    if (isValidDateInPast(dateString)) {
        return isMinimum18(dateString);
    } else {
        return false;
    }
}


export function berechneAlter(geburtstag, versicherungsbeginn, taggenau = false) {
    if (!geburtstag || !versicherungsbeginn) return 0;
    const geburtstagDate = moment(geburtstag, 'YYYY-MM-DD', true);
    
    // Unterstütze beide Formate: DD.MM.YYYY (Kombi) und YYYY-MM-DD (AR20)
    let versicherungsbeginnDate;
    if (versicherungsbeginn.includes('-')) {
        versicherungsbeginnDate = moment(versicherungsbeginn, 'YYYY-MM-DD', true);
    } else {
        versicherungsbeginnDate = moment(versicherungsbeginn, 'DD.MM.YYYY', true);
    }
    
    if (!geburtstagDate.isValid() || !versicherungsbeginnDate.isValid()) return 0;
    
    if (taggenau) {
        // Taggenau: Differenz in vollen Jahren (moment.diff berücksichtigt Tag und Monat)
        // Beispiel: Geb. 04.03.1971, Versbeginn 29.01.2026 -> Alter = 54 (noch kein 55. Geburtstag)
        return versicherungsbeginnDate.diff(geburtstagDate, 'years');
    } else {
        // Nicht taggenau: Nur Jahr minus Jahr (für Kombirechner)
        // Beispiel: Geb. 04.03.1971, Versbeginn 29.01.2026 -> Alter = 55
        return versicherungsbeginnDate.year() - geburtstagDate.year();
    }
}


export function getRechnerVariante(rechnerType, kanal) {
  // Kombi-Rechner: Unterscheidung nach Kanal
  if (rechnerType === 'kombi' || rechnerType === 'kombistat') {
    return kanal === 'meinevigo' ? '4YOU' : 'Kombi'
  }
  
  // ARN: Immer Nachhaltig
  if (rechnerType === 'arn') {
    return 'Nachhaltig'
  }
  
  // AR20: Immer AR20
  if (rechnerType === 'ar20') {
    return 'AR20'
  }
  
  // Fallback für unbekannte Rechner (z.B. Pflege)
  return null
}

export function getTarifCode(tarifNummer) {
  const mapping = {
    1: 'ZVS',
    2: 'ZVP',
    3: 'ZX2',
    4: 'S1',
    5: 'S2',
    6: 'AR20',
    7: 'ARNS',
    8: 'ARNF'
  }
  return mapping[tarifNummer] || null
}

export function getTarifName(tarifNummer) {
  const mapping = {
    1: 'Zahnvorsorge Basis',
    2: 'Zahnvorsorge Premium',
    3: 'Zahnersatz x2',
    4: '1-Bettzimmer',
    5: '2-Bettzimmer',
    6: 'AR20',
    7: 'ARNS',
    8: 'ARNF'
  }
  return mapping[tarifNummer] || null
}

export function berechneBeitrag(parAlter, parTarif, versicherungsbeginn = null, rechnerType = null, kanal = null) {
  

  // Wenn rechnerType und kanal übergeben wurden, verwende API-Daten
  if (rechnerType && kanal) {
    const variante = getRechnerVariante(rechnerType, kanal);
    
    // Falls keine Variante gefunden (z.B. Pflege), Fallback auf alte Logik
    if (!variante) {
      return berechneBeitragLegacy(parAlter, parTarif, versicherungsbeginn);
    }
    
    const tarifCode = getTarifCode(parTarif);
    
    if (!tarifCode) {
     
      return 0;
    }
    
    const tarifinfosStore = useTarifinfosStore();
    const beitrag = tarifinfosStore.getBeitragFuerAlter(variante, tarifCode, parAlter);
    
    if (beitrag === null) {
     
      return 0;
    }
    
    return beitrag;
  }
  
  // Fallback auf alte Logik, wenn keine Parameter übergeben
  return berechneBeitragLegacy(parAlter, parTarif, versicherungsbeginn);
}

// Legacy-Funktion für Rückwärtskompatibilität und Pflege-Rechner
function berechneBeitragLegacy(parAlter, parTarif, versicherungsbeginn = null) {
  let beitrag = 0;
  if (!versicherungsbeginn) {
    versicherungsbeginn = '01.07.2025';
  }
  let vbDate = null;
  if (typeof versicherungsbeginn === 'string' && versicherungsbeginn.includes('.')) {
    const [tag, monat, jahr] = versicherungsbeginn.split('.');
    vbDate = new Date(`${jahr}-${monat}-${tag}`);
  }
  const stichtag_2025_07_01 = new Date('2025-07-01');
  
  if (parTarif===1) {
    //ZVS
    beitrag = 4.9;
    if (parAlter>=20) { beitrag = 8.9; }    
  }

  if (parTarif===2) {
    //ZVP 
    beitrag = 19.9;
    if (parAlter >= 20) {
        beitrag = 16.9;
    }
  }

  if (parTarif===3) {
    //Zx2
    beitrag = 2.9;
    if (parAlter >= 20) { beitrag = 7.9; }
        if (parAlter >= 40) { beitrag = 14.9; }
        if (parAlter >= 65) { beitrag = 19.9; }
  }

  if (parTarif===4) {
    //S1
    switch (true) {
      case vbDate && vbDate >= stichtag_2025_07_01:
        beitrag = 5.6;
        if (parAlter>=20) { beitrag = 14.7; }
        if (parAlter>=45) { beitrag = 18.9; }
        if (parAlter>=60) { beitrag = 32.2; }
        if (parAlter>=70) { beitrag = 59.6; }
        if (parAlter>=80) { beitrag = 101.4; }
        break;
      default:
        beitrag = 12.5;
        if (parAlter >= 20) { beitrag = 20.4; }
        if (parAlter >= 45) { beitrag = 30.2; }
        if (parAlter >= 60) { beitrag = 41.3; }
        if (parAlter >= 70) { beitrag = 72.6; }
        if (parAlter >= 80) { beitrag = 111.4; }
        break;
    }
  }

  if (parTarif===5) {
    //S2
    switch (true) {
      case vbDate && vbDate >= stichtag_2025_07_01:
        beitrag = 2.1;
        if (parAlter>=20) { beitrag = 4.6; }
        if (parAlter>=45) { beitrag = 6.3; }
        if (parAlter>=60) { beitrag = 11.0; }
        if (parAlter>=70) { beitrag = 21.4; }
        if (parAlter>=80) { beitrag = 38.9; }
        break;
      default:
        beitrag = 4.0;
        if (parAlter >= 20) { beitrag = 8.5;  }
        if (parAlter >= 45) { beitrag = 13.3; }
        if (parAlter >= 60) { beitrag = 22.5; }
        if (parAlter >= 70) { beitrag = 41.6; }
        if (parAlter >= 80) { beitrag = 58.9; }
        break;
    }
  }

  return beitrag;
}

export function formatiereBeitrag(beitrag) {
    if (!beitrag) {
        return '- €';
    }
    return beitrag.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

export function formatiereInitialerBeitrag(beitrag) {
    if (!beitrag && beitrag !== 0) {
        return '- €';
    }
    const formatted = beitrag.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return `ab ${formatted} €`;
}

export function formatiertDatum(datum) {
    if(!datum) return '';
   return moment(datum).format('DD.MM.YYYY')
}

function ord(string) {
    return string.charCodeAt(0);
}

function sumDigits(number) {
    return String(number).split('').reduce((sum, digit) => sum + parseInt(digit), 0);
}

export function calculateTarifText(item) {
    let texts = [];

    if (item && item.tarif1 === 1) {
        texts.push('Zahnvorsorge Basis');
    }
    if (item && item.tarif2 === 1) {
        texts.push('Zahnvorsorge Premium');
    }
    if (item && item.tarif3 === 1) {
        texts.push('Zahnersatz x2');
    }
    if (item && item.tarif4 === 1) {
        texts.push('1-Bettzimmer');
    }
    if (item && item.tarif5 === 1) {
        texts.push('2-Bettzimmer');
    }

    return texts.join(' + ');
}

export function holeBankname(input) {
    if (input.trim().length === 0) {
        return Promise.resolve("");
    }
    return getBankname(input.trim())
        .then(response => {
            if (response.status >= 200 && response.status < 300 && response.data?.lang) {
                return response.data.lang;
            }
            return "";
        })
        .catch(() => "");
}

/**
 * Prüft ob ein Versicherungsbeginn für AR20 gültig ist
 * Gültig: heute bis max 6 Monate in der Zukunft
 * 
 * @param {string} dateString - Datum im Format YYYY-MM-DD oder DD.MM.YYYY
 * @returns {boolean} true wenn gültig, false sonst
 */
export function isValidVersicherungsbeginnAR20(dateString) {
    if (!dateString || typeof dateString !== 'string') return false;
    
    let date;
    if (dateString.includes('-')) {
        date = moment(dateString, 'YYYY-MM-DD', true);
    } else if (dateString.includes('.')) {
        date = moment(dateString, 'DD.MM.YYYY', true);
    } else {
        return false;
    }
    
    if (!date.isValid()) return false;
    
    const today = moment().startOf('day');
    const maxDate = moment().add(6, 'months').endOf('day');
    
    return date.isBetween(today, maxDate, 'day', '[]');
}

/**
 * Berechnet die Mindestlaufzeit für AR20/ARN Tarife
 * 
 * Regeln:
 * - Vertragsbeginn 01.01. eines Jahres → 12 Monate (bis 31.12. des gleichen Jahres)
 * - Vertragsbeginn >= 02.01. eines Jahres → Restmonate + 12 Monate Folgejahr
 * 
 * @param {string} versicherungsbeginn - Datum im Format YYYY-MM-DD oder DD.MM.YYYY
 * @returns {object} { monate: number, von: Date, bis: Date, vonStr: string, bisStr: string }
 */
export function berechneMindestlaufzeit(versicherungsbeginn) {
    if (!versicherungsbeginn) {
        return { monate: 0, von: null, bis: null, vonStr: '', bisStr: '' };
    }
    
    let startDate;
    
    // Parse das Datum (unterstützt YYYY-MM-DD und DD.MM.YYYY)
    if (versicherungsbeginn.includes('-')) {
        startDate = moment(versicherungsbeginn, 'YYYY-MM-DD', true);
    } else if (versicherungsbeginn.includes('.')) {
        startDate = moment(versicherungsbeginn, 'DD.MM.YYYY', true);
    } else {
        return { monate: 0, von: null, bis: null, vonStr: '', bisStr: '' };
    }
    
    if (!startDate.isValid()) {
        return { monate: 0, von: null, bis: null, vonStr: '', bisStr: '' };
    }
    
    const tag = startDate.date();
    const monat = startDate.month(); // 0-basiert (0 = Januar)
    const jahr = startDate.year();
    
    let endDate;
    let monate;
    
    // Prüfe ob Vertragsbeginn am 01.01.
    if (tag === 1 && monat === 0) {
        // 01.01. → Mindestlaufzeit bis 31.12. des gleichen Jahres = 12 Monate
        endDate = moment({ year: jahr, month: 11, day: 31 }); // 31.12.XXXX
        monate = 12;
    } else {
        // >= 02.01. → Restmonate des Jahres + 12 Monate Folgejahr
        endDate = moment({ year: jahr + 1, month: 11, day: 31 }); // 31.12.XXXX+1
        
        // Berechne Restmonate im aktuellen Jahr
        // Vom Startmonat bis Dezember (inkl.)
        const restMonateAktuellesJahr = 12 - monat;
        
        // Plus 12 Monate Folgejahr
        monate = restMonateAktuellesJahr + 12;
    }
    
    return {
        monate: monate,
        von: startDate.toDate(),
        bis: endDate.toDate(),
        vonStr: startDate.format('DD.MM.YYYY'),
        bisStr: endDate.format('DD.MM.YYYY')
    };
}

/**
 * Berechnet das Enddatum der Mindestlaufzeit + 1 Tag (Start des regulären Jahresbeitrags)
 * 
 * @param {string} versicherungsbeginn - Datum im Format YYYY-MM-DD oder DD.MM.YYYY
 * @returns {string} Datum im Format DD.MM.YYYY
 */
export function berechneJahresbeitragStart(versicherungsbeginn) {
    const mindestlaufzeit = berechneMindestlaufzeit(versicherungsbeginn);
    if (!mindestlaufzeit.bis) {
        return '';
    }
    
    // Tag nach Ende der Mindestlaufzeit = 01.01. des Folgejahres
    const startJahresbeitrag = moment(mindestlaufzeit.bis).add(1, 'day');
    return startJahresbeitrag.format('DD.MM.YYYY');
}

/**
 * Berechnet Erstbeitrag und Jahresbeitrag für AR20/ARN Tarife
 * 
 * @param {number} jahresbeitrag - Der Jahresbeitrag aus den Tarifinfos
 * @param {string} versicherungsbeginn - Datum im Format YYYY-MM-DD oder DD.MM.YYYY
 * @returns {object} { monatsbeitrag, erstbeitrag, jahresbeitrag, mindestlaufzeit }
 */
export function berechneAR20Beitraege(jahresbeitrag, versicherungsbeginn) {
    if (!jahresbeitrag || !versicherungsbeginn) {
        return {
            monatsbeitrag: 0,
            erstbeitrag: 0,
            jahresbeitrag: jahresbeitrag || 0,
            mindestlaufzeit: berechneMindestlaufzeit(versicherungsbeginn)
        };
    }
    
    const mindestlaufzeit = berechneMindestlaufzeit(versicherungsbeginn);
    const monatsbeitrag = jahresbeitrag / 12;
    const erstbeitrag = mindestlaufzeit.monate * monatsbeitrag;
    
    return {
        monatsbeitrag: monatsbeitrag,
        erstbeitrag: erstbeitrag,
        jahresbeitrag: jahresbeitrag,
        mindestlaufzeit: mindestlaufzeit
    };
}

